import { Box, Typography } from "@mui/material";

import MobileHeader from "../../../layout/OwnerLayout/Header";
import SurveyForm from "./SurveyForm";

export default function SurveyPage() {
  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            نظرسنجی
          </Typography>
        }
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          padding: "0px 8px 8px 8px",
        }}
      >
        <Box
          sx={{
            overflow: "auto",
            flex: "1",
          }}
        >
          <SurveyForm />
        </Box>
      </Box>
    </>
  );
}
